/*
 * File: product-toolbar-product-details.component.ts                          *
 * Project: catalog-cloud                                                      *
 * File Created: Monday, 7th March 2022 12:47:46                               *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Friday, 2nd December 2022 14:56:41                           *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */



import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Product } from '@nousmedis/cc-types';
import { ProductService } from '../../../services/product.service';

@Component({
  selector: 'app-product-toolbar-product-details',
  templateUrl: './product-toolbar-product-details.component.html',
  styleUrls: ['./product-toolbar-product-details.component.scss']
})
export class ProductToolbarProductDetailsComponent implements OnInit,OnDestroy {
  @Input() item:Product;
  imShow:boolean = true;
  selectedProduct:Subscription;
  imShowSubscription:Subscription;

  constructor(private productService:ProductService) { }
  ngOnDestroy(): void {
    // this.selectedProduct.unsubscribe();
    // this.imShowSubscription.unsubscribe();
  }


  ngOnInit(): void {
    // this.selectedProduct = this.productService.viewDetails.subscribe((product:Product)=>{
    //   this.item = product;
    // })
  }

  toogle(){
    // this.imShow = this.imShow ? false:true;
    if (this.imShow){
      document.getElementById('showInfo').classList.add("btn-hide-info");
      document.getElementById('product-info-title').classList.add("reduce-header-margin");
      document.getElementById('product-toolbar-details').classList.add("product-toolbar-details-expanded");
    }
    else {
      document.getElementById('showInfo').classList.remove("btn-hide-info");
      document.getElementById('product-info-title').classList.remove("reduce-header-margin");
      document.getElementById('product-toolbar-details').classList.remove("product-toolbar-details-expanded");
    }
  }
}
